import React from 'react';
import styled from 'styled-components';
import { Dialog, DialogActions, Button, TextField } from '@mui/material';

import * as theme from '../../theme';

// import icons
import { ReactComponent as AttentionIcon } from '../../assets/attention.svg';

const WarningDialog = () => {

    const [open, setOpen] = React.useState(window.location.origin.includes('test'));
    const [password, setPassword] = React.useState('');

    const handleSubmit = () => {
        if (password === 'BCITCourseTimetables') {
            setOpen(false);
        }
    };

    return (
        <StyledDialog open={open} fullWidth maxWidth="sm">
            <DialogContent>
                <Title>
                    <h3>Disclaimer</h3>
                </Title>
                <Content>
                    <AttentionIcon />
                    <p>You are about to enter the TEST site. Please be advised that parts of the data shown on this site
                        may be test data. Please enter password to continue.</p>
                </Content>
                <TextField
                    autoFocus
                    required
                    margin="dense"
                    label="Password"
                    fullWidth
                    variant="standard"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={handleSubmit} type="submit">Submit</Button>
            </DialogActions>
        </StyledDialog>
    );
};

export default WarningDialog;

const StyledDialog = styled(Dialog)`
    && {
        .MuiDialog-paper {
            border-radius: 10px;
        }
    }
`;

const DialogContent = styled.div`
    padding: 2em;
    background-color: #fff;
    display: flex;
    flex-direction: column;
    align-items: center;
`;

const Title = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    padding: 0px 10px 10px 10px;
    border-bottom: 1px solid rgba(51, 51, 51, 0.2);

    h3 {
        font-size: 16px;
        color: ${theme.colors.red};
        text-transform: uppercase;
        font-weight: bold;
        margin: 0;
    }

    svg {
        path {
            fill: ${theme.colors.red};
        }

        &:hover {
            cursor: pointer;
            opacity: 0.8;
        }
    }
`;

const Content = styled.div`
    display: flex;
    /* flex-direction: column; */
    align-items: center;
    justify-content: center;
    padding: 10px 10px 0px 10px;

    p {
        text-align: center;
        /* font-size: 18px; */
        font-size: 16px;
        /* padding: 0px 15px; */
        padding-left: 15px;
    }

    svg {
        width: 20%;
        height: auto;

        path {
            fill: ${theme.colors.red};
        }
    }
`;
